/**
 * Phase 36 — the Experiment card's words: the hint, the step summary, the
 * progress band's day words and the honesty line under every result.
 * For Media Devoted | Created By Ciro Autiero
 */
import { DROP_GEN_EXPERIMENT_MIN_SMS, type DropGenExperimentRow, EXPERIMENT_METRIC_WORDS } from '@trafficpulse/shared';

export const EXPERIMENT_HINT = 'Try a lane — a gateway with its own sender IDs — on a share of the drops for a few days, then compare it with the others and keep what works.';

export const EXPERIMENT_HONESTY = `Every drop sent through the experiment gateway counts on its side — reserved or pinned — and every other drop on the others’ side; the numbers are what the judge stored on its passes (a day is never refetched later). Under ${DROP_GEN_EXPERIMENT_MIN_SMS} SMS on either side no side is called. A reserved drop that finds its gateway at its daily capacity goes to the others like any drop.`;

export const dayWords = (e: DropGenExperimentRow): string =>
  e.dayOf <= 0 ? `starts ${ddmm(e.startDate)}` : e.dayOf > e.days ? `over — last day ${ddmm(e.endDate)}` : `day ${e.dayOf} of ${e.days}`;

export const ddmm = (iso: string): string => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;

export const STATUS_WORDS: Record<DropGenExperimentRow['status'], string> = {
  RUNNING: 'running',
  DONE: 'over — result ready',
  APPLIED: 'applied',
  STOPPED: 'stopped early',
};

/** The step card's one line. `label` names the experiment's lane ("C · 23Telecom · AUSSIEWIN"). */
export function experimentSummary(running: DropGenExperimentRow | undefined, latest: DropGenExperimentRow | undefined, label: (e: DropGenExperimentRow) => string): string {
  if (running) return `running · ${dayWords(running)} · ${label(running)} gets ${running.sharePct} % of the drops · ${EXPERIMENT_METRIC_WORDS[running.metric]}`;
  if (latest && latest.status !== 'APPLIED') return `${STATUS_WORDS[latest.status]} · ${label(latest)} on the ${EXPERIMENT_METRIC_WORDS[latest.metric]} — apply the winner or start another`;
  if (latest) return `last one applied (${latest.appliedAction}) · start another to test again`;
  return 'none — test a lane on a share of the drops for a few days';
}

export const METRIC_OPTIONS = (Object.keys(EXPERIMENT_METRIC_WORDS) as Array<keyof typeof EXPERIMENT_METRIC_WORDS>).map((value) => ({ value, label: EXPERIMENT_METRIC_WORDS[value] }));
